import Axios from "axios";

const BASE_URL_V1 = `${process.env.REACT_APP_API_URL}/api/v1`;

// CONTROLL process.env.NODE_ENV
const URL_COMMUNITIES = BASE_URL_V1 + "/communities/";

export function updateUser(
  token,
  userId,
  communityId,
  data,
  callback,
  errorCallback
) {
  const url = URL_COMMUNITIES + communityId + "/users/" + userId;
  Axios.patch(url, data, getConfig(token))
    .then((response) => callback(response.data.data))
    .catch((error) => errorCallback(error.response));
}

export function validateUserToken(idToken, callback, errorCallback) {
  const url = URL_COMMUNITIES + "confirmUserToken/" + idToken;
  Axios.get(url)
    .then((response) => callback(response.data.data))
    .catch((error) => errorCallback(error.response));
}
function getConfig(token) {
  return { headers: { authorization: "Bearer " + token } };
}



// WEBPACK FOOTER //
// ./src/helpers/ApiManager.js